<template>
<!--  <div>-->
    <vz-direction
      ref="direction"
      :location-guid="orderStore.orderForm.directions.destination.locationGuid"
      v-model:address="orderStore.orderForm.directions.destination.address"
      v-model:direction="orderStore.orderForm.directions.destination.direction"
      v-model:terminal-guid="orderStore.orderForm.directions.destination.terminalGuid"
      v-model:pickup-point-guid="orderStore.orderForm.directions.destination.pickupPointGuid"
      :cost="destinationCost"
      :has-pup-cost="hasPupCost"
      :disabled="disabled"
      :location-search-options="locationSearchOptions"
      use-map
      direction-to
      terminal-purpose="to"
      title-card="Прибытие"
      selector-title="Населенный пункт"
      @update:direction="onDirectionChange"
      @update:location-guid="onLocationChange"
      @update:address="onAddressChange"
      v-bind="$attrs"
    >
    </vz-direction>
    <div v-if="!isPupEmpty">
      <vz-destination-direction-calendar
        :disabled="disabled || !!orderStore.costDisabledReason"
        :hide-waiting="hideWaiting"
      />
    </div>
<!--  </div>-->
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import {useCityStore} from '~/stores/city';
import VzDirection from '~/components/personal/order/direction/vz-direction.vue';
import VzDestinationDirectionCalendar
  from '~/components/personal/order/direction/vz-destination-direction-calendar.vue';
import {Location, OrderDirectionAddress} from '~/types/types';
import {asyncComputed} from '@vueuse/core';
import {toRefs} from "@vue/reactivity";

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  hideWaiting: {
    type: Boolean,
    default: false
  }
})

const { $showToast } = useNuxtApp()
const orderStore = useOrderStore()
const {hasPupCost} = toRefs(useOrderStore())
const { locationByGuid } = useCityStore()
const direction = ref<typeof VzDirection|null>(null)

// Если редактируем заказ и отправка заблокирована, то город прибытия можно менять только в пределах района
const editOrderDestinationCityGuid = ref('')

const destinationCost = computed(() => {
  return orderStore.orderPrice?.address?.destination?.price?.total
    ? ` (${orderStore.orderPrice?.address?.destination?.price?.total} ${orderStore.orderPriceCurrency.currency})`
    : ''
})

const locationSearchOptions = computed(() => {
  const meta = orderStore.orderForm.meta
  const result: any = { purpose: 'order', dispatch: orderStore.orderForm.directions.dispatch.locationGuid }

  if (meta && meta.lockState?.dispatch && editOrderDestinationCity.value) {
    result.rcl = editOrderDestinationCity.value.rcl_guid || editOrderDestinationCity.value.guid || undefined
    result.search = editOrderDestinationCity.value.name || ''
  }

  return result
})

const isPupEmpty = computed(() => {
  return orderStore.orderForm.directions.destination.direction === 'pickupPoint'
    && !orderStore.orderForm.directions.destination?.pickupPointGuid?.length
})

const editOrderDestinationCity = asyncComputed(async () => {
  return editOrderDestinationCityGuid.value
    ? await locationByGuid(editOrderDestinationCityGuid.value)
    : false
})

function onDirectionChange() {
  orderStore.orderForm.directions.destination.calendar.date = ''
}

async function onLocationChange(guid: string, location?: Location) {
  orderStore.orderForm.directions.destination.locationGuid = guid

  if (location) {
    orderStore.destinationLocation = location
    orderStore.orderForm.directions.destination.country = location.country || orderStore.orderForm.directions.destination.country
    // Смена страны участника
    const customer = orderStore.orderForm.customer.destination
    customer.country = orderStore.orderForm.directions.destination.country || customer.country
  }
}

function onAddressChange(value: string, obj: OrderDirectionAddress) {
  if (obj) {
    orderStore.orderForm.directions.destination.region = obj.region

    if (obj?.offerWaitingTime && obj.offerWaitingTime > 30 && obj.offerWaitingTime > orderStore.orderForm.directions.destination.waitingTime) {
      const time = orderStore.waitingTimeList.list[obj.offerWaitingTime]
      $showToast({
        title: 'Время ожидания',
        text: `По данному адресу замечены частые случаи простоя машины. Рекомендуем заранее указать предполагаемое время: ${time}`,
        variant: 'warning',
        autocloseDelay: 20000,
        cancelButtonText: 'Не нужно',
        buttonText: 'Подтвердить',
        buttonCB: () => {
          orderStore.orderForm.directions.destination.waitingTime = obj.offerWaitingTime || 30
        }
      })
    }
  }
}

watch(
  () => orderStore.orderForm.meta?.guid,
  (value) => {
    editOrderDestinationCityGuid.value = value && orderStore.orderForm.meta?.lockState?.dispatch
      ? orderStore.orderForm.directions.destination.locationGuid
      : ''
  },
  { immediate: true }
)

watch(
  () => [orderStore.orderForm.directions.dispatch.calendar.to, orderStore.orderForm.directions.dispatch.calendar.terminalTime, orderStore.timetable],
  () => {
    if (!orderStore.isCalendarLocked) {
      orderStore.updateSplit()
    }
  }
)

watch(
  () => [orderStore.orderForm.directions.dispatch.address, orderStore.orderForm.directions.destination.address],
  () => {
    if (
      orderStore.orderForm.directions.destination.calendar.date &&
      (orderStore.orderForm.directions.dispatch.address || orderStore.orderForm.directions.destination.address)
    ) {
      orderStore.getOrderPriceAction().then()
    }
  }
)

watch(
  () => orderStore.timetablePayload,
  (value, oldValue) => {
    if (JSON.stringify(value) !== JSON.stringify(oldValue)) {
      orderStore.setDefaultDate()
    }
  },
  { flush: 'pre' }
)
</script>

<style lang="scss">

</style>
